var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#LinkedIn_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 19h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.5 16.5h-2.67v-4.55c0-1.247-.475-1.944-1.462-1.944-1.074 0-1.635.726-1.635 1.944v4.55H8.159V7.833h2.574v1.168s.774-1.432 2.613-1.432S16.5 8.69 16.5 11.013zM5.088 6.699a1.593 1.593 0 0 1-1.588-1.6c0-.883.711-1.599 1.588-1.599s1.587.716 1.587 1.6c0 .882-.71 1.599-1.587 1.599M3.758 16.5h2.685V7.833H3.759z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LinkedIn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 1h18v18H1z"
  })))));
};
export default SvgLinkedIn;